import * as React from 'react';
import { IFskBanner } from '../../types/fsk';
import * as styles from './styles.css';

export interface IFSKMortgageBannerProps {
  bannerInfo: IFskBanner;
  onBannerClick(): void;
}

export const FSKMortgageBanner = React.forwardRef<HTMLAnchorElement, IFSKMortgageBannerProps>(
  ({ onBannerClick, bannerInfo }, ref) => {
    return (
      <a className={styles['container']} href={bannerInfo.link} onClick={onBannerClick} ref={ref}>
        <img src={bannerInfo.image} alt="Ипотека у ФСК" width={bannerInfo.width} height={bannerInfo.height} />
      </a>
    );
  },
);

FSKMortgageBanner.displayName = 'FSKMortgageBanner';
